export default __webpack_public_path__ + "static/media/26.ea94d666.png";